import { FilterParams } from '@synergy/models';
import { FormControl, MenuItem, SelectChangeEvent } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { FilterSelectBase } from './components/filter-select-base';
import { StyledLabel } from './components/styled-label';
import { useFilter } from '../filter-context';

const options = [
    { value: 'undefined', displayValue: 'app.filter.relevance' },
    { value: 'currentMinimumPrice|asc', displayValue: 'app.filter.price', icon: '\u2191' },
    { value: 'currentMinimumPrice|desc', displayValue: 'app.filter.price', icon: '\u2193' },
];

export const FilterPriceSort = (): ReactElement => {
    const { updateFilter, filter } = useFilter();

    const sort = filter.get(FilterParams.SortBy);
    const order = filter.get(FilterParams.SortDirection);
    const currentValue = (sort && order && `${sort}|${order}`) ?? 'undefined';

    const handleChange = (event: SelectChangeEvent<string>): void => {
        filter.delete(FilterParams.SortBy);
        filter.delete(FilterParams.SortDirection);
        if (event.target.value !== 'undefined') {
            const params = event.target.value.split('|');
            filter.set(FilterParams.SortBy, params[0]);
            filter.set(FilterParams.SortDirection, params[1]);
        }
        updateFilter(filter);
    };

    const renderValue = (selected: string): ReactElement => {
        const selectedName = options.find(option => option.value === selected)?.displayValue;
        return (
            <>
                <StyledLabel isSelected={selected !== 'undefined'}>
                    {<FormattedMessage id="app.filter.order" />}{' '}
                </StyledLabel>
                <FormattedMessage id={selectedName} />
            </>
        );
    };

    return (
        <FormControl sx={{ maxWidth: '100%' }}>
            <FilterSelectBase onChange={handleChange} renderValue={renderValue} value={currentValue}>
                {options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        <FormattedMessage id={option.displayValue} /> {option.icon}
                    </MenuItem>
                ))}
            </FilterSelectBase>
        </FormControl>
    );
};
